import { ArrowDownIcon, CaretDownIcon, CaretSortIcon, EyeNoneIcon } from '@radix-ui/react-icons';
import type { Column } from '@tanstack/react-table';

import { Button } from '../button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '../dropdown-menu';

import type { JSX } from 'react';

interface DataTableHeaderColumnProps<TData, TValue> {
  column: Column<TData, TValue>;
  enableHiding?: boolean;
  enableSorting?: boolean;
  labelSorting?: 'numeric' | 'alphabetic';
  title: string | JSX.Element;
}

export function DataTableHeaderColumn<TData, TValue>({
  column,
  enableHiding = true,
  enableSorting = true,
  labelSorting = 'alphabetic',
  title,
}: DataTableHeaderColumnProps<TData, TValue>) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild disabled={!enableSorting && !enableHiding}>
        <Button className="rounded-lg disabled:opacity-100" variant="ghost">
          {title}
          {column.getIsSorted() === 'desc' || (column.getIsSorted() === 'asc' && enableSorting) ? (
            <CaretDownIcon className="ml-2 size-4" />
          ) : enableSorting ? (
            <CaretSortIcon className="ml-2 size-4" />
          ) : null}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start">
        {!enableSorting ? null : (
          <>
            <DropdownMenuItem
              className="grid grid-cols-3"
              onClick={() => {
                column.toggleSorting(false);
              }}
            >
              <ArrowDownIcon className="size-4 text-muted-foreground" />
              <span className="col-span-2">{labelSorting === 'alphabetic' ? 'A-Z' : '0-10'}</span>
            </DropdownMenuItem>
            <DropdownMenuItem
              className="grid grid-cols-3"
              onClick={() => {
                column.toggleSorting(true);
              }}
            >
              <ArrowDownIcon className="size-4 text-muted-foreground" />
              <span className="col-span-2">{labelSorting === 'alphabetic' ? 'Z-A' : '10-0'}</span>
            </DropdownMenuItem>
          </>
        )}

        {!enableHiding ? null : (
          <DropdownMenuItem
            className="grid grid-cols-3"
            onClick={() => {
              column.toggleVisibility(false);
            }}
          >
            <EyeNoneIcon className="size-4 text-muted-foreground" />
            <span className="col-span-2">Ocultar</span>
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
